import { Procedure } from "@shared/models";
import { TableProperty } from "@shared/components/Table/interfaces";

import { procedureTableProperties } from "./procedureTableProperties";

/** A Procedure row augmented with its semantic-search relevance score, for the ranked table only. */
export interface SemanticProcedureRow extends Procedure {
  score: number;
}

export const semanticProcedureTableProperties: TableProperty<SemanticProcedureRow>[] = [
  ...procedureTableProperties,
  {
    title: "Relevance",
    key: "score",
    get: (item) => `${Math.round(item.score * 100)}%`,
  },
];
